var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }